import SupportChat from "@/components/SupportChat";
export default function SuperSupport() {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="font-display text-3xl font-bold text-white">Merchant support</h1>
        <p className="text-slate-400 text-sm mt-1">Live conversations from every store. Reply here to help a merchant unblock.</p>
      </div>
      <SupportChat scope="admin" />
    </div>
  );
}
